module.exports = __webpack_public_path__ + "img/onboarding7.d513a7fa.png";